/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './CardLegitimation.scss';
import { ButtonRadio } from '@core/ButtonRadio';
import { appCardStyle, appIconsPath, appLinkSize, appLinkStyle } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { Link } from '@core/Link';

export function CardLegitimation({
  cardStyle = appCardStyle.DEFAULT,
  image = null,
  text = '',
  redirectionLabel = 'Link',
  handleRedirection = '#',
  value = false
}) {
  const [isSelected, setIsSelected] = React.useState(value);

  return (
    <div
      className={`${cardStyle} rounded p-16`}
      role="button"
      tabIndex={-1}
      onClick={() => setIsSelected(!isSelected)}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          console.log('Enter key pressed');
        }
      }}>
      <div className="row align-items-center">
        <div className="col-2 pe-16 d-flex justify-content-center">
          <ButtonRadio value={isSelected} />
        </div>
        <div className={`${!image && 'bg-primary'} col-2 align-content-center p-0 rounded-3`}>
          {image && (
            <img
              src={image}
              alt="card-icon"
              className="img-fluid object-fit-cover w-100"
              style={{ maxHeight: '64px' }}
            />
          )}
        </div>

        <div className="col-8 ps-16">
          <div
            className="ek-copy-sm-14-medium pb-12 text-wrap"
            dangerouslySetInnerHTML={{ __html: text }}
          />
          <Link
            label={redirectionLabel}
            iconRight={appIconsPath.ARROW_RIGHT_SMALL}
            linkStyle={
              cardStyle === appCardStyle.DEFAULT_GRADIENT
                ? appLinkStyle.PRIMARY
                : appLinkStyle.SECONDARY
            }
            linkSize={appLinkSize.SMALL}
            linkRef={handleRedirection}
          />
        </div>
      </div>
    </div>
  );
}

CardLegitimation.propTypes = {
  cardStyle: PropTypes.string,
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  redirectionLabel: PropTypes.string.isRequired,
  handleRedirection: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired
};

export default CardLegitimation;
